import React, { useState } from 'react';
import { gql, useQuery, useMutation } from '@apollo/client';
import './Zones.css';

const GET_ZONES = gql`
  query { defenseZones { id name type geometryJson createdBy createdAt active } }
`;
const CREATE_ZONE = gql`
  mutation CreateZone($input: ZoneInput!) {
    createZone(input: $input) { id name type }
  }
`;
const DELETE_ZONE = gql`
  mutation DeleteZone($id: ID!) { deleteZone(id: $id) }
`;

export default function Zones() {
  const { data, refetch } = useQuery(GET_ZONES);
  const [createZone] = useMutation(CREATE_ZONE);
  const [deleteZone] = useMutation(DELETE_ZONE);
  const [form, setForm] = useState({ name: '', type: 'WARNING' as 'WARNING'|'DEFENSE', lat: '', lng: '', radius: '500' });

  const handleCreate = async (e: React.FormEvent) => {
    e.preventDefault();
    const lat = parseFloat(form.lat);
    const lng = parseFloat(form.lng);
    const r = parseFloat(form.radius);
    if (isNaN(lat) || isNaN(lng) || isNaN(r)) return;

    // Build GeoJSON circle (approximated as polygon)
    const points = 32;
    const coords = Array.from({ length: points + 1 }, (_, i) => {
      const angle = (i / points) * 2 * Math.PI;
      const dlng = (r / 111320) / Math.cos(lat * Math.PI / 180) * Math.sin(angle);
      const dlat = (r / 111320) * Math.cos(angle);
      return [lng + dlng, lat + dlat];
    });
    const geometryJson = { type: 'Polygon', coordinates: [coords] };

    await createZone({ variables: { input: { name: form.name, type: form.type, geometryJson } } });
    setForm({ name: '', type: 'WARNING', lat: '', lng: '', radius: '500' });
    refetch();
  };

  const handleDelete = async (id: string) => {
    if (!window.confirm('Delete this zone?')) return;
    await deleteZone({ variables: { id } });
    refetch();
  };

  return (
    <div className="page-container">
      <div className="page-header"><h2>🔰 Defense Zones</h2></div>

      <form className="add-form zone-form" onSubmit={handleCreate}>
        <input className="input-field" placeholder="Zone name" value={form.name} onChange={e => setForm(f=>({...f, name: e.target.value}))} required />
        <select className="input-field" value={form.type} onChange={e => setForm(f=>({...f, type: e.target.value as any}))}>
          <option value="WARNING">Warning Zone</option>
          <option value="DEFENSE">Defense Zone</option>
        </select>
        <input className="input-field" placeholder="Latitude" value={form.lat} onChange={e => setForm(f=>({...f, lat: e.target.value}))} required />
        <input className="input-field" placeholder="Longitude" value={form.lng} onChange={e => setForm(f=>({...f, lng: e.target.value}))} required />
        <input className="input-field" placeholder="Radius (m)" value={form.radius} onChange={e => setForm(f=>({...f, radius: e.target.value}))} />
        <button className="btn-primary" type="submit">+ Create Zone</button>
      </form>

      <div className="zones-grid">
        {(data?.defenseZones || []).map((z: any) => (
          <div key={z.id} className={`zone-card ${z.type.toLowerCase()}`}>
            <div className="zone-header">
              <span className="zone-type-icon">{z.type === 'DEFENSE' ? '🔴' : '🟡'}</span>
              <div>
                <div className="zone-name">{z.name}</div>
                <div className="zone-type-label">{z.type} ZONE</div>
              </div>
            </div>
            <div className="zone-meta">
              <span>By: {z.createdBy || 'system'}</span>
              <span>{new Date(z.createdAt).toLocaleDateString()}</span>
            </div>
            <button className="btn-danger btn-sm" onClick={() => handleDelete(z.id)}>🗑 Delete</button>
          </div>
        ))}
        {(data?.defenseZones || []).length === 0 && <div className="no-data">No zones defined</div>}
      </div>
    </div>
  );
}
